export class CloseRoute {
    constructor(public path: string, public domainCode: string) {
    }
}